/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import core, { Entities } from '@gin-betting/core';

import { MARK_REACHABLE_ENTITIES } from './constants';

const {
    utils: { makeAction },
} = core;

export const markReachableEntities = (entityName: Entities.EntityNames) => {
    return makeAction(MARK_REACHABLE_ENTITIES, {
        entityName,
    });
};
